import { PatientWebSettingsConfigV1 } from '@csp/config-schemas';
import { Maybe, PatientWebSettingsConfig } from '@csp/csp-common-model';
import { PatientWebSettingsConfigValidationService } from './PatientWebSettingsConfigValidationService';

const toPatientWebSettingsConfig = (config: Maybe<PatientWebSettingsConfigV1>): Maybe<PatientWebSettingsConfig> => {
  if (config) {
    PatientWebSettingsConfigValidationService.validatePatientWebSettingsConfig(config);

    return config;
  } else {
    return undefined;
  }
};

export const PatientWebSettingsConfigService = {
  toPatientWebSettingsConfig,
};
